import request from "../../assets/js/Request.js";

// 获取基层透析会议图片
export const getImage = (params) => {
  return request.post("getJkjlhsList",params);
};
